module.exports = __webpack_public_path__ + "img/banner.af4d03f3.png";